import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=0ea927ac&scoped=true&"
import script from "./chatItem.vue?vue&type=script&lang=js&"
export * from "./chatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea927ac",
  null
  
)

export default component.exports